import { Property } from '../models';
import React from 'react';
import { observer } from 'mobx-react';
import { AntCheckbox } from '../../../ant/antCheckbox';
import { linkModel } from '../../../../../framework/mobx-integration';
import { FormBuilderContext } from '../formBuilderContext';
import { HelpIcon } from '../../formEntryNew';
import { AntFlex } from 'controls/react/ant/antFlex';
import b_ from 'b_';
import './ceCheckBox.less';

const b = b_.with('ce-check-box');

export const CECheckbox = observer(({ property }: { property: Property }) => {
	const store = React.useContext(FormBuilderContext);
	return (
		<AntFlex justify="space-between">
			<AntCheckbox disabled={store.propertyDisabled(property)} {...linkModel(store.value, property.id)}>
				{property.caption}
			</AntCheckbox>
			<HelpIcon tooltip={property.tooltip} className={b('help-icon')} />
		</AntFlex>
	);
});
